import React from 'react';
import { StyledTooltipBasic } from './style';

const TooltipBasic = ({ children }) => (
  <StyledTooltipBasic>{children}</StyledTooltipBasic>
);

export default TooltipBasic;
